import { createBasket, updateBasket } from '@store/basket/actions';
import Cookie from 'js-cookie';
import { Dispatch } from 'redux';
import { SpaPackageBasketItem } from 'shared-types/Basket';
import { withoutSpaDaysAlreadyInBasket } from './spaDaysAlreadyInBasket';

type AddSpaDaysToBasketParams = {
  dispatch: Dispatch;
  propertyId: number;
  language: string;
  basketItems: unknown[];
  spaDays: SpaPackageBasketItem[];
};

export function addSpaDaysToBasket({
  dispatch,
  propertyId,
  language,
  basketItems,
  spaDays,
}: AddSpaDaysToBasketParams): Promise<unknown> | null {
  const newSpaDays = withoutSpaDaysAlreadyInBasket(basketItems, spaDays);
  if (spaDays.length && !newSpaDays.length) return null;

  if (basketItems.length) {
    const basketId = Cookie.get('basketId') as string;
    const items = [...basketItems, ...newSpaDays];
    return dispatch(
      updateBasket(propertyId, basketId, language, { items }, false, true) as any
    ) as unknown as Promise<unknown>;
  }

  return dispatch(
    createBasket(propertyId, language, { items: newSpaDays }, true) as any
  ) as unknown as Promise<unknown>;
}
